import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import {
  AuthModalTypes,
  useAuthModalContext,
} from '../context/AuthModalContext';
import { useUserContext } from '../context/UserContext';
import { RESERVATIONS_CONFIRMED_PATH } from '../paths';

export const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useUserContext();
  const { closeModal, openModal } = useAuthModalContext();

  useEffect(() => {
    if (isLoading || isAuthenticated) {
      return undefined;
    }

    openModal(AuthModalTypes.SIGN_IN, {
      nonClosable: true,
      hideCreateAccount: true,
      onAuthSuccess: () => {
        navigate(RESERVATIONS_CONFIRMED_PATH, { replace: true });
      },
    });

    return () => {
      closeModal();
    };
  }, [isAuthenticated, isLoading]);

  if (!isLoading && isAuthenticated) {
    return <Navigate replace to={RESERVATIONS_CONFIRMED_PATH} />;
  }

  return null;
};
